import React, { FC, useState } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import { iconSize } from '../../../../constants/icon.constants';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import Icon from '../../../@shared/icon';
import Picture from '../../../@shared/picture';
import { TRegionSelector, TSplashComponentRegion } from '../../types/splashComponent.types';
import MarketSelector from '../marketSelector';

const RegionSelector: FC<TRegionSelector> = ({ model }) => {
    const [selectedRegion, setSelectedRegion] = useState<TSplashComponentRegion | null>();
    const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx.md})`);

    const handleRegionSelection = (region: TSplashComponentRegion) => {
        if (selectedRegion?.id === region.id) {
            setSelectedRegion(null);
            return;
        }
        setSelectedRegion(region);
    };

    return (
        <div className='region-selector'>
            <Text field={model.title} tag="div" className="region-selector__title" />
            {model.regions.map((eachRegionSet) => (
                <>
                    {isWide && (
                        <div className='region-selector-continent-row__container'>
                            <div className='region-selector-continent-row'>
                                <div className='region-selector-continent' key={eachRegionSet.id}>
                                    <Picture
                                        editorialImageProps={{
                                            mobileImage: eachRegionSet.fields.regionSelectionImage,
                                            mobileTransformation: 'Size200',
                                            cssClassImageEl: 'region-selector-continent__flag',
                                            cssClassPictureEl: 'region-selector-continent__flag-wrapper'
                                        }}
                                    />
                                    <Text tag='p' field={eachRegionSet.fields.title} className='region-selector-continent__title' />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className='region-selector-market-row'>
                        <div key={eachRegionSet.id} className={`region-selector-market${selectedRegion?.id === eachRegionSet.id ? ' region-selector-market--active' : ''}`}>
                            {!isWide && (
                                <div className={'region-selector-market__heading'} onClick={() => handleRegionSelection(eachRegionSet)}>
                                    <Picture
                                        editorialImageProps={{
                                            mobileImage: eachRegionSet.fields.regionSelectionImage,
                                            mobileTransformation: 'Size200',
                                            cssClassImageEl: 'region-selector-market__flag',
                                            cssClassPictureEl: 'region-selector-market__flag-wrapper'
                                        }}
                                    />
                                    <Text tag='p' field={eachRegionSet.fields.title} className='region-selector-market__title' />
                                    <Icon
                                        iconName={`arrow-chevron-${selectedRegion?.id === eachRegionSet.id ? 'up' : 'down'}`}
                                        size={iconSize['dsk']}
                                        color="primary"
                                        extraClassName='region-selector-market__chevron-icon'
                                    />
                                </div>
                            )}
                            {(isWide ? true : selectedRegion?.id === eachRegionSet.id) && <MarketSelector markets={eachRegionSet.fields.markets} />}
                        </div>
                    </div>
                </>
            ))}
        </div>
    )
};

export default RegionSelector;
